import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";
import { IEvent } from "../models/get";

/**
 * Gibt alle Benutzer zurück.
 */
export function getUsers(): JQueryPromise<modelsGet.IUser[]>
{
    var endpoint = new URI("api/users");

    return api.get<modelsGet.IUser[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine bestimmten Benutzer zurück.
 */
export function getUser(id: number): JQueryPromise<modelsGet.IUser>
{
    var endpoint = new URI("api/users");
    endpoint.segment(id.toString());

    return api.get<modelsGet.IUser>({
        endpoint: endpoint.href()
    });
}

export function getUserInfo(username: string): JQueryPromise<modelsGet.IUser>
{
    var endpoint = new URI("api/users/userinfo");
    endpoint.segment(username);

    return api.get<modelsGet.IUser>({
        endpoint: endpoint.href()
    });
}

export function getChangesets(id: number): JQueryPromise<modelsGet.IChangeset<IEvent>[]>
{
    var endpoint = new URI("api/users");
    endpoint.segment(id.toString());
    endpoint.segment("changesets");

    return api.get<modelsGet.IChangeset<IEvent>[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(person: modelsPost.IUser): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/users/create",
        data: JSON.stringify(person)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, person: modelsPost.IUser): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/users/edit/${id}`,
        data: JSON.stringify(person)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/users/delete/${id}`
    });
}